// Unsaved-edit protection: a thin wrapper over sessionStorage so an in-progress
// List / Template / Checklist edit survives an accidental navigation or refresh
// and can be offered back on the next visit. sessionStorage (not localStorage)
// is deliberate: a draft should outlive a refresh or an in-tab navigation, but
// not linger for days after the tab is closed.

let storageOverride: Storage | undefined;
let useOverride = false;

function getStorage(): Storage | undefined {
  if (useOverride) return storageOverride;
  try {
    return globalThis.sessionStorage;
  } catch {
    return undefined;
  }
}

/** Test-only seam. Vitest runs in node, where sessionStorage does not exist. */
export function __setStorageForTests(s: Storage | undefined): void {
  useOverride = true;
  storageOverride = s;
}

/** `neattick-draft:{resourceKind}:{resourceId}` — one slot per editor page.
 *  For an unsaved new resource the id is the literal `"new"`. */
export function draftKey(resourceKind: "list" | "template" | "checklist", resourceId: string): string {
  return `neattick-draft:${resourceKind}:${resourceId}`;
}

export function saveDraft(key: string, data: unknown): void {
  try {
    getStorage()?.setItem(key, JSON.stringify(data));
  } catch {
    // Quota / Safari private mode throws on write; never break editing over it.
  }
}

export function loadDraft(key: string): unknown | null {
  try {
    const raw = getStorage()?.getItem(key);
    if (raw == null) return null;
    return JSON.parse(raw) as unknown;
  } catch {
    return null;
  }
}

export function clearDraft(key: string): void {
  try {
    getStorage()?.removeItem(key);
  } catch {
    // ignore
  }
}
